import React, { FC, useState } from 'react'
import { observer } from 'mobx-react'
import './index.scss'

interface ITypeItem {
  value: string;
  label: string;
}

interface IProps {
  value: any;
  types: ITypeItem[];
  defaultType?: string;
  onChange?: (val: string) => any;
}

const Tabs: FC<IProps> = (props: IProps) => {
  const {
    value,
    types,
    defaultType,
    onChange
  } = props
  // type change
  const handleChange = (val: any) => {
    onChange && onChange(val)
  }
  return (
    <>
      <div className='mkt-switch-tab'>
        {
          types.map((item: any) => (
            <div className={`tab-item ${value === item.value ? 'select' : ''}`} key={item.value} data-cypid={`useSwitchTab_${item.value}`} onClick={() => handleChange(item.value)}>
              <span>{item.label}</span>
              {value === item.value && <div className='select-line'></div>}
            </div>
          ))
        }
      </div>
    </>
  )
}

export default observer(Tabs)
